import apiService from "./BaseApi";
import { auth } from "@/firebase"
const ENDPOINT_CLIENT_PATH = "users/client/findAll";
const ENDPOINT_FRANCHISEE_PATH = "users/franchisee/findAll";
const ENDPOINT_ClIENTBYFRANCHISEE_PATH = "/users/clients/byFranchisee";
const ENDPOINT_PERMISSIONS_PATH = "users/permissions/findAll";
import store from '@/store/index'
const UsersService = {
    getUsers: async () => {
        const response = await apiService.post("users/findAll", { currentUserId: store.state.currentUser?.uid });
        return response.data.data;
    },
    createUser: async (user) =>
        apiService.post("users", {
            currentUserId: store.state.currentUser?.uid,
            user,
        }),
    deleteUser: async (idUser) =>
        apiService.post("users/delete", {
            currentUserId: store.state.currentUser?.uid,
            uid: idUser,
        }),
    updateUser: async (idUser, user) =>
        apiService.put(`users/${encodeURIComponent(idUser)}`, {
            currentUserId: store.state.currentUser?.uid,
            user,
        }),
    getUsersById: async (idUser) => {
        const response = await apiService.post("users/findById", { idUser, currentUserId: store.state.currentUser?.uid });
        return response.data.data;
    },
    getAssociatesByIdClient: async (idClient) => {
        const response = await apiService.post("users/associates/findByClient", { idClient, currentUserId: store.state.currentUser?.uid });
        return response.data.data;
    },
    findAllFranchisee: async () => apiService.post(ENDPOINT_FRANCHISEE_PATH, { currentUserId: store.state.currentUser?.uid }),
    findAllClients: async () => apiService.post(ENDPOINT_CLIENT_PATH, { currentUserId: store.state.currentUser?.uid }),
    findClientsByFranchisee: async (idFranchisee) => apiService.post(ENDPOINT_ClIENTBYFRANCHISEE_PATH, { currentUserId: store.state.currentUser?.uid, idFranchisee }),
    findAllPermissions: async () => apiService.post(ENDPOINT_PERMISSIONS_PATH, { currentUserId: auth.currentUser.uid }),
};

export default UsersService;
